export default {
  admin: {
    name: 'admin',
    title: 'Admin',
  },
  reader: {
    name: 'reader',
    title: 'Reader',
  },
};
